import { render, staticRenderFns } from "./BigScene.vue?vue&type=template&id=bd731742&scoped=true"
import script from "./BigScene.vue?vue&type=script&lang=js"
export * from "./BigScene.vue?vue&type=script&lang=js"
import style0 from "./BigScene.vue?vue&type=style&index=0&id=bd731742&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd731742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd731742')) {
      api.createRecord('bd731742', component.options)
    } else {
      api.reload('bd731742', component.options)
    }
    module.hot.accept("./BigScene.vue?vue&type=template&id=bd731742&scoped=true", function () {
      api.rerender('bd731742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Scene/BigScene.vue"
export default component.exports